/**
 * @file 제안서 API
 * 제안서 목록 조회, 단건 상세 조회, 파일 업로드, 삭제 등을 처리합니다.
 */

import qs from "qs";
import { api } from "../../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const proposalApi = {
    /** 제안서 목록 조회
     * @param {object} params - 필터 파라미터 (배열 값은 repeat 방식으로 직렬화)
     */
    getList: (params) => api.get(`${API_BASE}/proposal/list`, params, {
        paramsSerializer: { serialize: (p) => qs.stringify(p, { arrayFormat: "repeat" }) },
    }),

    /** 제안서 상세 조회
     * @param {number} id - 제안서 ID
     */
    getById: (id)       => api.get(`${API_BASE}/proposal/${id}`),

    /** 제안서 파일 업로드 (multipart/form-data)
     * @param {FormData} formData - 업로드할 파일이 담긴 FormData
     */
    upload:  (formData) => api.upload(`${API_BASE}/proposal/upload`, formData),

    /** 제안서 삭제
     * @param {number} id - 제안서 ID
     */
    delete:  (id)       => api.delete(`${API_BASE}/proposal/${id}`),
};
